import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  questions: [],
  currentQuestionIndex: 0,
  answers: {},
  isSubmitted: false,
};

const testSlice = createSlice({
  name: "test",
  initialState,
  reducers: {
    setQuestions: (state, action) => {
      state.questions = action.payload;
    },
    setCurrentQuestionIndex: (state, action) => {
      state.currentQuestionIndex = action.payload;
    },
    setAnswer: (state, action) => {
      const { questionId, answer } = action.payload;
      state.answers[questionId] = answer;
    },
    submitTest: (state) => {
      state.isSubmitted = true;
    },
    resetTest: (state) => {
      state.questions = [];
      state.currentQuestionIndex = 0;
      state.answers = {};
      state.isSubmitted = false;
    },
  },
});

export const {
  setQuestions,
  setCurrentQuestionIndex,
  setAnswer,
  submitTest,
  resetTest,
} = testSlice.actions;

export default testSlice.reducer;
